import React, { Component } from 'react';
import './documentmanagement.css';
import { showNotification } from '../../StatusNotification';
import { showConfirmation } from '../../ConfirmationModal';

export class DocumentDeletion extends Component {
    static displayName = DocumentDeletion.name;

    constructor(props) {
        super(props);
        this.state = {
            documents: [],
            toDelete: []
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleDeleteCheckboxChange = (e) => {
        const id = e.target.dataset.id;
        const isChecked = e.target.checked;

        this.setState(prevState => {
            let newToDelete = [...prevState.toDelete];

            if (isChecked) {
                // Add ID to array if not already present
                if (!newToDelete.includes(id)) {
                    newToDelete.push(id);
                }
            } else {
                // Remove ID from array
                const index = newToDelete.indexOf(id);
                if (index > -1) {
                    newToDelete.splice(index, 1);
                }
            }

            return { toDelete: newToDelete };
        });
    }

    deleteItems = async (e) => {
        e.preventDefault();

        if (this.state.toDelete.length === 0) {
            showNotification("Please select items to delete", "error");
            return;
        }

        let confirmDelete = await showConfirmation("Are you sure you want to delete the selected items?");
        if (!confirmDelete) {
            return;
        }

        let allSuccess = true;
        let errorMessages = [];

        for (let i = 0; i < this.state.toDelete.length; i++) {
            try {
                const response = await fetch('AdminDocument/DeleteDocument?documentId=' + this.state.toDelete[i], {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });

                const data = await response.json();

                if (data !== "Deleted") {
                    allSuccess = false;
                    errorMessages.push(`Document ${this.state.toDelete[i]}: ${data}`);
                }
            } catch (error) {
                allSuccess = false;
                errorMessages.push(`Document ${this.state.toDelete[i]}: Network error`);
            }
        }

        if (allSuccess) {
            // Clear the selection and refresh the data
            this.setState({ toDelete: [] });
            this.getComponentData();
            showNotification("All documents deleted successfully", "success");
        } else {
            showNotification("Some deletions failed:\n" + errorMessages.join("\n"), "error");
            // Still refresh to show current state
            this.setState({ toDelete: [] });
            this.getComponentData();
        }
    }

    render() {
        let documents = this.state.documents;
        let table = null;

        if (documents.length > 0) {
            table = (
                <table>
                    <thead>
                        <tr>
                            <th>Select</th>
                            <th>Name</th>
                            <th>Type/Department</th>
                            <th>Description</th>
                            <th>Uploader</th>
                            <th>Timestamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {documents.map((document, i) => {
                            if (document.status === "Deleted") return null;

                            let timestamp = new Date(document.timestamp.toString());
                            let timestampFormat = (timestamp.getMonth() + 1) + "/" + timestamp.getDate() + "/" + timestamp.getFullYear();

                            return (
                                <tr key={document.id || i}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            data-id={document.id}
                                            checked={this.state.toDelete.includes(document.id.toString())}
                                            onChange={this.handleDeleteCheckboxChange}
                                        />
                                    </td>
                                    <td>{document.name}</td>
                                    <td>{document.type}</td>
                                    <td>{document.description}</td>
                                    <td>{document.uploader}</td>
                                    <td>{timestampFormat}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        }

        return (
            <div className='document-management'>
                <div className='page-title'>
                    <h1>Document Deletion</h1>
                </div>

                <div className='table-container'>
                    <button onClick={this.deleteItems} className='form-management-button'>Delete Selected</button>
                    {table}
                </div>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminDocument/GetDocuments', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            documents: data
        });
    }
}